import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";

/* ---------- FIXED SELECT STYLE ---------- */
const fixedSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 38,
    height: 38,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 38,
    padding: "0 8px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 38,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const CanteenSale = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const saleId = location.state?.id;
  const isEditMode = Boolean(saleId);

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [project, setProject] = useState(null);

  const [rows, setRows] = useState([
    { item: null, availableQty: 0, quantity: "" },
  ]);

  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);

  const token = localStorage.getItem("token");
  const centerCode = localStorage.getItem("code");
  const sewadarId = localStorage.getItem("sewadarId");

  /* ---------- YOUR AVAILABLE QTY FUNCTION ---------- */
  const getAvailableQty = async (itemId, department = "Canteen") => {
    const res = await apiClient.get(`${SERVER_BASE}/getAvailableQuantity`, {
      params: {
        item: itemId,
        location: `${department} : Store`,
        status: "As stock",
        department,
      },
    });
    return res.data?.availableQuantity || 0;
  };

  /* ---------- FETCH INVENTORY ---------- */
  const fetchInventory = async () => {
    const res = await apiClient.get(
      `${SERVER_BASE}/getItemsByGroupAndItem`,
      {
        params: {
          groupCodes: ["G", "O", "F", "D"],
          selectedTypeValues: ["Consumables"],
          code: centerCode,
        },
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setInventoryOptions(
      res.data.map((i) => ({
        value: i.id,
        label: `${i.printName}${
          i.additionalNames ? ` - [ ${i.additionalNames} ]` : ""
        }`,
        uom: i.uom,
      }))
    );
  };

  /* ---------- FETCH PROJECTS ---------- */
  const fetchProjects = async () => {
    const res = await apiClient.get(`${SERVER_BASE}/area-projects`);
    setProjectOptions(
      res.data.map((p) => ({
        value: p.id,
        label: `${p.projectName} ${p.projectCode?`[ ${p.projectCode} ]`:''}`,
      }))
    );
  };

  /* ---------- FETCH SALE (EDIT MODE) ---------- */
  const fetchSale = async (id) => {
    const res = await apiClient.get(`${SERVER_BASE}/canteen-sale/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const sale = res.data;

    setDate(sale.saleDate);
    setTime(sale.saleTime);
    setProject(
      projectOptions.find((p) => p.value == sale.projectId)
    );

   const mappedRows = await Promise.all(
  sale.items.map(async (i) => {
    const backendQty = await getAvailableQty(i.itemId);

    return {
      item: {
        value: i.itemId,
        label: i.printName,
        uom: i.uom,
      },
      quantity: i.quantity,

      // 🔴 IMPORTANT FIX
      availableQty: backendQty + Number(i.quantity),
    };
  })
);

    setRows(mappedRows);
  };

  useEffect(() => {
    fetchInventory();
    fetchProjects();
  }, []);

  useEffect(() => {
    if (isEditMode && projectOptions.length) {
      fetchSale(saleId);
    }
  }, [isEditMode, projectOptions]);

  /* ---------- ROW HANDLERS ---------- */
  const addRow = () => {
    setRows([...rows, { item: null, availableQty: 0, quantity: "" }]);
  };

  const deleteRow = (index) => {
    if (rows.length === 1) return;
    setRows(rows.filter((_, i) => i !== index));
  };
const handleItemChange = async (index, selected) => {
  if (!selected) return;

  const backendQty = await getAvailableQty(selected.value);

  if (backendQty <= 0 && !isEditMode) {
    Swal.fire(
      "Out of Stock",
      "Selected item has no available quantity",
      "warning"
    );
    return;
  }

  setRows((prev) => {
    const updated = [...prev];
    updated[index] = {
      item: selected,
      quantity: "",
      availableQty: backendQty, // always backend qty for new selection
    };
    return updated;
  });
};




  // const handleQtyChange = (index, value) => {
  //   const qty = Number(value);

  //   setRows((prev) => {
  //     const updated = [...prev];
  //     if (qty > updated[index].availableQty) return prev;
  //     updated[index].quantity = value;
  //     return updated;
  //   });
  // };


  const handleQtyChange = (index, value) => {
  const qty = Number(value);

  if (qty < 0) {
    Swal.fire("Invalid Quantity", "Quantity cannot be negative", "error");
    return;
  }

  setRows((prev) => {
    const updated = [...prev];
    const row = updated[index];

    if (qty > row.availableQty) {
      Swal.fire(
        "Quantity Exceeded",
        `Available quantity is ${row.availableQty}`,
        "error"
      );
      return prev;
    }

    row.quantity = value;
    return updated;
  });
};


  /* ---------- SAVE VALIDATION ---------- */
const isSaveDisabled = useMemo(() => {
  if (!date || !time || !project) return true;

  return rows.some(
    (r) =>
      !r.item ||
      !r.quantity ||
      Number(r.quantity) <= 0 ||
      Number(r.quantity) > r.availableQty
  );
}, [date, time, project, rows]);


  /* ---------- SAVE ---------- */
//   const handleSave = async () => {
//     const payload = {
//       date,
//       time,
//       projectId: project.value,
//       projectName: project.label,
//       items: rows.map((r) => ({
//         itemId: r.item.value,
//         printName: r.item.label,
//         quantity: Number(r.quantity),
//         uom: r.item.uom,
//       })),
//     };

//     if (isEditMode) {
//       await apiClient.put(
//         `${SERVER_BASE}/canteen-sale/${saleId}`,
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       alert("Canteen sale updated");
//     } else {
//       await apiClient.post(
//         `${SERVER_BASE}/canteen-sale`,
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       alert("Canteen sale saved");
//     }

//     navigate("../canteen-sale-list");
//   };
const getFilteredInventoryOptions = (currentIndex) => {
  const selectedItemIds = rows
    .map((r, idx) => (idx !== currentIndex ? r.item?.value : null))
    .filter(Boolean);

  return inventoryOptions.filter(
    (opt) => !selectedItemIds.includes(opt.value)
  );
};



const handleSave = async () => {
  const savedPin = localStorage.getItem("pin");

  if (!savedPin) {
    Swal.fire("Error", "PIN not configured for this user", "error");
    return;
  }

  const { value: enteredPin } = await Swal.fire({
    title: "Enter PIN",
    input: "password",
    inputLabel: "Confirm PIN to proceed",
    inputPlaceholder: "Enter PIN",
    inputAttributes: {
      maxlength: 6,
      autocapitalize: "off",
      autocorrect: "off",
    },
    showCancelButton: true,
    confirmButtonText: "Verify",
  });

  if (!enteredPin) return;

  if (enteredPin != savedPin) {
    Swal.fire("Invalid PIN", "PIN does not match", "error");
    return;
  }

  const payload = {
    date,
    time,
    projectId: project.value,
    projectName: project.label,
    items: rows.map((r) => ({
      itemId: r.item.value,
      printName: r.item.label,
      quantity: Number(r.quantity),
      uom: r.item.uom,
    })),
    sewadarId:sewadarId,
    centerCode:centerCode
  };

  try {
    if (isEditMode) {
      await apiClient.put(
        `${SERVER_BASE}/canteen-sale/${saleId}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      Swal.fire("Success", "Canteen sale updated", "success");
    } else {
      await apiClient.post(
        `${SERVER_BASE}/canteen-sale`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      Swal.fire("Success", "Canteen sale saved", "success");
    }

    navigate("../canteen-sale-list");
  } catch (err) {
    Swal.fire("Error", "Failed to save canteen sale", "error");
  }
};

  return (
    <div className="formcontainer mt-5">
        <div className="d-flex gap-3">
        <button className="btn btn-secondary btn-sm" onClick={()=>{navigate('../canteen-sale-list')}}>Back</button>
      <h4>{isEditMode ? "Edit Canteen Sale" : "Canteen Sale"}</h4>
</div>
      {/* HEADER */}
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Date</label>
          <input
            type="date"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        <div className="col-md-4">
          <label>Project</label>
          <Select
            value={project}
            onChange={setProject}
            options={projectOptions}
          />
        </div>

        <div className="col-md-4">
          <label>Time</label>
          <input
            type="time"
            className="form-control"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
        </div>
      </div>

      {/* TABLE */}
      <table className="table table-bordered align-middle">
        <thead>
          <tr>
            <th style={{ width: 60 }}>S.No</th>
            <th style={{ width: 350 }}>Item</th>
            {!isEditMode && <th style={{ width: 120 }}>Available Qty</th>}
            <th style={{ width: 80 }}>UOM</th>
            <th style={{ width: 150 }}>Quantity</th>
            <th style={{ width: 120 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>{index + 1}</td>

              <td>
                <Select
                  value={row.item}
                  onChange={(v) => handleItemChange(index, v)}
                  options={getFilteredInventoryOptions(index)}
                  styles={fixedSelectStyles}
                  menuPortalTarget={document.body}
                  placeholder="Select item"
                />
              </td>

     {!isEditMode && (
  <td className="text-center fw-semibold">  
    {row.availableQty}
  </td>
)}



              <td className="text-left">
                {row.item?.uom || "-"}
              </td>

              <td>
                <input
                  type="number"
                  className="form-control"
                  value={row.quantity}
                  disabled={!row.item}
                  onChange={(e) =>
                    handleQtyChange(index, e.target.value)
                  }
                />
              </td>

              <td className="text-center">
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={addRow}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => deleteRow(index)}
                  disabled={rows.length === 1}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-end">
        <button
          className="btn btn-success"
          disabled={isSaveDisabled}
          onClick={handleSave}
        >
          {isEditMode ? "Update" : "Save"}
        </button>
      </div>
    </div>
  );
};

export default CanteenSale;
